import { render } from "./IVkAd.vue?vue&type=template&id=63a57eee"
import script from "./IVkAd.vue?vue&type=script&lang=js"
export * from "./IVkAd.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__